// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PFastBackwardOutlinedSvg from "@fishx/icons-svg/es/asn/PFastBackwardOutlined";
import FishxIcon from '../components/FishxIcon';

var PFastBackwardOutlined = function PFastBackwardOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PFastBackwardOutlinedSvg
  }));
};

PFastBackwardOutlined.displayName = 'PFastBackwardOutlined';
export default React.forwardRef(PFastBackwardOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PFastBackwardOutlined.js
// module id = 3378
// module chunks = 0